import { Observable, Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import {
  ConfiguratorMultiChoiceAnswerRequest,
  ConfiguratorSessionContent,
  ConfiguratorSingleChoiceAnswerRequest,
} from '../models/unit-accessories-configuration-v6.model';

@Injectable({
  providedIn: 'root',
})
export class UnitAccessoriesConfigurationV6Service {
  private readonly baseUrl: string;

  #accessoryUpdate = new Subject<void>();

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/declaro-cpq';
  }

  readonly accessoryUpdated$ = this.#accessoryUpdate.asObservable();

  emitAccessoryUpdate(): void {
    this.#accessoryUpdate.next();
  }

  getCurrentSessionNodeContent(sessionId: string): Observable<ConfiguratorSessionContent> {
    return this.http.get<ConfiguratorSessionContent>(`${this.baseUrl}/${sessionId}/content`);
  }

  setSingleChoiceAnswer(
    singleChoiceAnswerRequest: ConfiguratorSingleChoiceAnswerRequest
  ): Observable<ConfiguratorSessionContent> {
    return this.http.post<ConfiguratorSessionContent>(
      `${this.baseUrl}/${singleChoiceAnswerRequest.sessionId}/questions-groups/${singleChoiceAnswerRequest.groupId}/questions/${singleChoiceAnswerRequest.questionId}/answer/single-choice`,
      {
        selectedOptionId: singleChoiceAnswerRequest.selectedOptionId,
        unitId: singleChoiceAnswerRequest.unitId,
        unitType: singleChoiceAnswerRequest.unitType,
        projectId: singleChoiceAnswerRequest.projectId,
      }
    );
  }

  setMultiChoiceAnswer(
    multiChoiceAnswerRequest: ConfiguratorMultiChoiceAnswerRequest
  ): Observable<ConfiguratorSessionContent> {
    return this.http.post<ConfiguratorSessionContent>(
      `${this.baseUrl}/${multiChoiceAnswerRequest.sessionId}/questions-groups/${multiChoiceAnswerRequest.groupId}/questions/${multiChoiceAnswerRequest.questionId}/answer/multi-choice`,
      {
        selectedOptionsIds: multiChoiceAnswerRequest.selectedOptionsIds,
        unitId: multiChoiceAnswerRequest.unitId,
        unitType: multiChoiceAnswerRequest.unitType,
        projectId: multiChoiceAnswerRequest.projectId,
      }
    );
  }
}
